import { render, staticRenderFns } from "./newFunction.vue?vue&type=template&id=506219d0&scoped=true"
import script from "./newFunction.vue?vue&type=script&lang=js"
export * from "./newFunction.vue?vue&type=script&lang=js"
import style0 from "./newFunction.vue?vue&type=style&index=0&id=506219d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506219d0",
  null
  
)

export default component.exports